import AbstractListerField from 'MyAccount/Listings/EbayListing/ListerField/AbstractListerField';
import FlatButton from 'material-ui/FlatButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import ChildrenFader from 'shared/components/ChildrenFader';
import React from 'react';
import * as Colors from 'material-ui/styles/colors';
import _ from 'lodash';
import {UPLOAD_TYPES} from 'MyAccount/Listings/EbayListing/consts';
import UploadImageToS3Button from 'shared/components/UploadImageToS3Button';
import UploadImageToEbayButton from 'shared/components/UploadImageToEbayButton';

export class ButtonAndHeadline extends AbstractListerField {
  getButton() {
    const {uploadType} = this.props;
    return uploadType === UPLOAD_TYPES.EBAY ? UploadImageToEbayButton : UploadImageToS3Button;
  }

  render() {
    const {errorText, photosAmountLeft, selectedImages, deleteImages, id, ...other} = this.props;
    const headlineStyle = {marginLeft: 20, color: Colors.grey500};
    const showDeleteButton = !_.isEmpty(selectedImages);
    const button = this.getButton();
    let headline;
    if (errorText) {
      headline = errorText;
      headlineStyle.color = Colors.red700;
    } else if (photosAmountLeft > 0) {
      headline = `Upload up to ${photosAmountLeft} more photos`;
    } else if (photosAmountLeft === 0) {
      headline = `You've reached the maximum amount of photos`;
    }
    return (
      <div style={{marginBottom: 20, display: 'flex', justifyContent: 'space-between'}}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          {React.createElement(button, {
            disabled: photosAmountLeft <= 0,
            photosAmountLeft,
            id,
            ...other,
          })}
          <span style={headlineStyle}>{headline}</span>
        </div>
        <ChildrenFader visible={showDeleteButton} transitionDurationMs={150}>
          <FlatButton
            id={`${id}-delete`}
            label="DELETE"
            icon={<DeleteIcon />}
            style={{color: Colors.red700}}
            onClick={() => deleteImages(_.keys(selectedImages))}
          />
        </ChildrenFader>
      </div>
    );
  }
}
